// import update from "immutability-helper";
import {
  SET_API_CLIENT_PAYLOAD,
  ADD_REQUEST_PARAMETER,
  REMOVE_REQUEST_PARAMETER,
  ONCHANGE_HANDLER,
  ADD_UPDATE_API_COLLECTION,
  REMOVE_API_COLLECTION,
  SET_VARIABLE_FIELDS,
  SET_AUTO_MAPPING_FIELDS,
  SET_SELECTED_COLLECTION,
  SET_API_RESPONSE,
  SET_RELATED_WINDOW_FIELDS,
  SET_DEFAULT_CONTENT_TYPE,
  SET_FORMULA_FIELD_DATA,
  SET_VARIABLES_PAYLOAD,
  SET_MAPPING_FIELD_DATA,
  SET_AUTO_MAPPING_FILTERED_FIELDS,
  SET_ARRAY_OBJECT_FIELDS,
  SET_WINDOW_FIELDS,
  SET_INPUT_VARIABLES
} from "../actionTypes/ApiClientActionTypes";
import {getQueryVariable} from '../../Utils/CommonFunctions';

// authorization: {
//   type: "",
//   key: "",
//   value: "",
//   add_to: "",
//   token: "",
//   username: "",
//   password: ""
// }
const initialState = {
  variableFields:{
    field_type:[],
    variable_type:[]
  },
  arrayObjectFields:{},
  windowFields:{},
  variablesPayload:[],
  mappingFields:[],
  autoMappingFields:[],
  autoMappingFilteredFields:[],
  formulaFieldsData:{
    functions:[],
    operators:[],
    supported_fields:[]
  },
  inputValuesPayload:[],
  apiResponse:{type:'SINGLE',data:[],reqIndex:null,isSideBarOpen:true},
  selectedCollectionId:0,
  selectedHistoryId:null,
  selectedObj:{},
  relatedWindowFields:{},
    collectionDetails:{
        collection_name: "",
        description: "",
        window_id: "",
        related_windows: [],
        module_id:'',
        is_collection: false,
        collection_filters: [],
        api_requests: [],
        collection_variables:[],
        
    },
    
};

const ApiClientReducer = (state = initialState, action) => {
const {collectionDetails,apiResponse,arrayObjectFields,windowFields} = state;
let updateCollectionDetails = null;
let reqIndex = null,reqParamIndex=null,paramName=null;
const {payload,type} = action
let updatedState = null;
  switch (type) {
    case SET_VARIABLE_FIELDS:
    return{
        ...state,
        variableFields:payload
      }
    case SET_AUTO_MAPPING_FIELDS:
      return{
        ...state,
        autoMappingFields:payload
      }  
    case SET_AUTO_MAPPING_FILTERED_FIELDS:
      return{
        ...state,
        autoMappingFilteredFields:payload
      } 
    case SET_FORMULA_FIELD_DATA:
      return{
        ...state,
        formulaFieldsData:payload
      } 

    case SET_VARIABLES_PAYLOAD:
        return{
          ...state,
          variablesPayload:payload
        } 
    case SET_MAPPING_FIELD_DATA:
      return{
        ...state,
        mappingFields:payload
      }  
    case SET_ARRAY_OBJECT_FIELDS:
        const {varId,fields} = payload;
        updatedState = {
          ...arrayObjectFields,
          [varId]:fields
        }
        return{
          ...state,
          arrayObjectFields:updatedState
        }
    case SET_INPUT_VARIABLES:
          return{
            ...state,
            inputValuesPayload:payload
        }
    case SET_WINDOW_FIELDS:
          const {winFields} = payload;
          const winId = payload.winId;
          updatedState = {
            ...windowFields,
            [winId]:winFields
          }
        return{
            ...state,
            windowFields:updatedState
        } 
    case SET_RELATED_WINDOW_FIELDS:
      const {relatedWindowFields} = payload;
      return{
        ...state,
        relatedWindowFields:relatedWindowFields
      }  
    case SET_API_CLIENT_PAYLOAD:
        updatedState = {
           ...payload,
        }
      return {
        ...state,
        collectionDetails:{...updatedState},
        // apiResponse:[]
      }
    case SET_DEFAULT_CONTENT_TYPE:
      reqIndex = payload.reqIndex;
      // console.log('payload',payload);
      updateCollectionDetails  = {
        ...collectionDetails,
        api_requests:collectionDetails.api_requests.map((item,itemIndex)=>{
          let returnData = {
            ...item
          }
          if(reqIndex===itemIndex && payload.type==='FORM'){
            const contentTypeIndex = item['request_parameters']['headers'].findIndex((head)=>head.key.toLowerCase()==='content-type');
            if(contentTypeIndex===-1){
              item['request_parameters']['headers'] = [
                ...item['request_parameters']['headers'],
                {
                  key: "Content-Type",
                  value: "application/x-www-form-urlencoded",
                  line_no: (item['request_parameters']['headers'].length+1)
                }
              ]
            }
            // console.log('contentTypeIndex',contentTypeIndex);
            // item['request_parameters']['headers'] = [...item['request_parameters']['headers']].filter((req)=>{
            //   if(req.key.toLowerCase()!=='content-type'){
            //     return req;
            //   }
            // })

            
            // returnData = {
            //   ...item,
            //   ['request_parameters']:{
            //     ...item['request_parameters'],
            //     ['headers']:[
            //       ...item['request_parameters']['headers'],
            //       {
            //         key: "Content-Type",
            //         value: "application/x-www-form-urlencoded",
            //         line_no: (item['request_parameters']['headers'].length+1)
            //       }
            //     ]
            //   }
            // }
          }
          return returnData;
        })
      }
      return{
        ...state,
        collectionDetails:{...updateCollectionDetails}
      }
    case ADD_REQUEST_PARAMETER:
      reqIndex = payload.reqIndex;
      paramName = payload.paramName;
      updateCollectionDetails  = {
        ...collectionDetails,
        api_requests:collectionDetails.api_requests.map((item,itemIndex)=>{
          let returnData = {
            ...item
          }
          if(itemIndex===reqIndex){
            returnData = {
              ...item,
              request_parameters:{
                ...item['request_parameters'],
                [paramName]:[
                  ...item['request_parameters'][paramName],
                  {
                    key: "",
                    value: "",
                    line_no: (item['request_parameters'][paramName].length+1)
                  }
                ]
              }
            }
          }
          return returnData;
        })
      }
      return{
        ...state,
        collectionDetails:{...updateCollectionDetails}
      } 
      
    case REMOVE_REQUEST_PARAMETER:
      reqIndex = payload.reqIndex;
      paramName = payload.paramName;
      reqParamIndex = payload.reqParamIndex;
        updateCollectionDetails  = {
          ...collectionDetails,
          api_requests:collectionDetails.api_requests.map((item,itemIndex)=>{
            let returnData = {
              ...item
            }
            if(itemIndex===reqIndex){
              returnData = {
                ...item,
                request_parameters:{
                  ...item['request_parameters'],
                  [paramName]:item['request_parameters'][paramName].filter((itm, itmIndex) => {
                    return reqParamIndex !== itmIndex; // return true to keep the item, false to filter it out
                  })
                }
              }
            }
            return returnData;
          })
        }
        return{
          ...state,
          collectionDetails:{...updateCollectionDetails}
        } 
    case ADD_UPDATE_API_COLLECTION:
      const {collectionObj,actn} = payload;
      // console.log('collectionObj',collectionObj,actn);
      if(actn==='ADD'){
        updateCollectionDetails  = {
          ...collectionDetails,
          api_requests:[...collectionDetails.api_requests,{
            request_name:collectionObj.collectionName,
            description:collectionObj.collectionDesc,
            http_verb:0,
            request_url:'',
            request_format: 'TEXT',
            response_body:'',
            line_number: collectionDetails.api_requests.length,
            request_parameters: {
              headers:[],
              query_params:[]
            }
          }]
        }
      }else if(actn==='UPDATE'){ 
        updateCollectionDetails  = {
          ...collectionDetails,
          api_requests:collectionDetails.api_requests.map((item,itemIndex)=>{
            let updateItem = item;
            if(itemIndex===collectionObj.reqIndex){
              updateItem =  {
                ...item,
                request_name:collectionObj.collectionName,
                description:collectionObj.collectionDesc,
              };
            }
            return updateItem;
          })
        }
      }else if(actn==='DELETE'){ 
        updateCollectionDetails  = {
          ...collectionDetails,
          api_requests:collectionDetails.api_requests.filter((item,itemIndex)=>{
            return (itemIndex!==collectionObj.reqIndex)
          })
        }
      }
      
      return{
        ...state,
        collectionDetails:{...updateCollectionDetails},
        // apiResponse:[]
      }  
    case REMOVE_API_COLLECTION:
      reqIndex = payload.reqIndex;
      updateCollectionDetails  = {
        ...collectionDetails,
        api_requests:collectionDetails.api_requests.filter((item,itemIndex)=>{
          return (itemIndex!==reqIndex)
        })
      }
    return{
      ...state,
      collectionDetails:{...updateCollectionDetails},
      // apiResponse:[]
    }
    case ONCHANGE_HANDLER:
      const {type,obj,selectedValue,keys,isInsertExp} = payload;
      reqIndex = keys.reqIndex;
      // const isClick = keys.isClick;
      updateCollectionDetails = {
        ...collectionDetails,
      }
      const allowedData = {
        '1stLevel':['request_url','request_body'],
        'onBlur':['request_url','request_body'],
        'query_params':['value','key'],
        'headers':['value','key'],
        'authorization':['key','value','token','username','password']
      }
      if(isInsertExp===true){
        if(allowedData[type].indexOf(obj)===-1){
          return{
            ...state,
          }
        }
      }
      // console.log('payload',payload);
      reqParamIndex = keys.reqParamIndex;
        if(type==='1stLevel'){
            updateCollectionDetails['api_requests'][reqIndex][obj] = selectedValue;
        }else if(type==='onBlur'){
          const {url,query} = getQueryVariable(selectedValue);
          updateCollectionDetails['api_requests'][reqIndex][obj] = url;
          query.forEach((q)=>{
            const isAllowAdd = updateCollectionDetails['api_requests'][reqIndex]['request_parameters']['query_params'].some(item => item.key === q.key );
          //  console.log('isAllowAdd',q.key,updateCollectionDetails['api_requests'][reqIndex]['request_parameters']['query_params'],isAllowAdd);
            if(isAllowAdd===false){
              updateCollectionDetails['api_requests'][reqIndex]['request_parameters']['query_params'].push({
                key:q.key,
                value:q.value
              });
            }
          })
        }else if(type==='query_params' || type==='headers'){
          updateCollectionDetails['api_requests'][reqIndex]['request_parameters'][type][reqParamIndex][obj] = selectedValue;
        }else if(type==='authorization'){
          let updateAuthorization = updateCollectionDetails['api_requests'][reqIndex]['request_parameters'];
          if(!updateAuthorization[type]){
            updateAuthorization = {
              ...updateAuthorization,
              [type]:{
  
              }
            }
          }
          if(!updateAuthorization[type][obj]){
            updateAuthorization = {
              ...updateAuthorization,
              [type]:{
                ...updateAuthorization[type],
                [obj]:''
              }
            }
          }
          updateAuthorization[type][obj] = selectedValue;
          updateCollectionDetails['api_requests'][reqIndex]['request_parameters'] = updateAuthorization;
         
        }
      
        return{
          ...state,
            collectionDetails:{...updateCollectionDetails},
            selectedObj:{
              ...payload,
              type:(payload.type==='onBlur')?'1stLevel':payload.type
            }
        }  
    case SET_SELECTED_COLLECTION:
      const {selectedId,hisIndex} = payload;
      return{
        ...state,
        selectedCollectionId:selectedId,
        selectedHistoryId:hisIndex,
        apiResponse:{
          ...apiResponse,
          type:'SINGLE'
        }
      }  
    case SET_API_RESPONSE:
      const {responseType,responseData,isSideBarOpen} = payload;
      return{
        ...state,
        apiResponse:{
          type:responseType,
          data:responseData,
          isSideBarOpen:isSideBarOpen,
          reqIndex:payload.reqIndex
        }
      }        
    default:
      return state;
  }
};

export default  ApiClientReducer;
